/*
 * Kunde-returlabel — storefront form handler.
 * To trin: 1) POST {order_number, email} finder ordren og viser
 * valgmuligheder + evt. allerede oprettede labels. 2) POST samme + return_type
 * opretter (eller genbruger) selve GLS-labelen.
 * Indgange: ?ordre=&email= (fra Min konto, auto-submit) og ?token= (gensyn af
 * en tidligere oprettet label).
 * Mønster: assets/faktura-anmod.js (inflight-guard, statusbeskeder, samme
 * fetch-stil uden custom headers — kun Content-Type/Accept, CORS-allowlistet).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-retur]');
  if (!root) return;

  var backend = root.getAttribute('data-backend') || '';
  var supportEmail = root.getAttribute('data-support-email') || 'kundeservice@jmdimensions.com';
  if (!backend) return;

  var requestForm = root.querySelector('[data-retur-request-form]');
  var requestBtn = root.querySelector('[data-retur-request-submit]');
  var msg = root.querySelector('[data-retur-msg]');
  var orderNumberEl = root.querySelector('[data-retur-order-number]');
  var existingWrap = root.querySelector('[data-retur-existing]');
  var existingList = root.querySelector('[data-retur-existing-list]');
  var optionButtons = root.querySelectorAll('[data-retur-option]');
  var resultPdfWrap = root.querySelector('[data-retur-result-pdf]');
  var resultQrWrap = root.querySelector('[data-retur-result-qr]');
  var resultMailWrap = root.querySelector('[data-retur-result-mail]');
  var pdfLink = root.querySelector('[data-retur-pdf-link]');
  var qrImg = root.querySelector('[data-retur-qr-img]');
  var trackingWrap = root.querySelector('[data-retur-tracking-wrap]');
  var trackingEl = root.querySelector('[data-retur-tracking]');
  var backBtn = root.querySelector('[data-retur-back]');
  if (!requestForm || !requestBtn || !msg) return;

  var TYPE_LABELS = { ShopReturn: 'Print label', ShopReturnQR: 'QR-kode', ShopReturnMail: 'Email' };

  var requestBtnLabel = requestBtn.textContent;
  var requestInflight = false;
  var optionsInflight = false;
  var currentOrderNumber = '';
  var currentEmail = '';
  var currentToken = null;

  function setMsg(text, type) {
    msg.textContent = text;
    msg.className = 'retur-msg is-visible is-' + type;
  }
  function clearMsg() {
    msg.className = 'retur-msg';
    msg.textContent = '';
  }
  function showView(name) {
    root.querySelectorAll('[data-retur-view]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-retur-view') === name);
    });
  }
  function setRequestLoading(loading) {
    requestInflight = loading;
    requestBtn.disabled = loading;
    requestBtn.textContent = loading ? 'Slår op…' : requestBtnLabel;
  }
  function setOptionsLoading(loading) {
    optionsInflight = loading;
    optionButtons.forEach(function (btn) { btn.disabled = loading; });
  }
  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('da-DK');
    } catch (e) {
      return '';
    }
  }

  function parseResponse(res) {
    return res.json().then(function (data) { return { status: res.status, data: data }; })
      .catch(function () { return { status: res.status, data: {} }; });
  }

  function renderExisting(list) {
    existingList.innerHTML = '';
    if (!list || !list.length) {
      existingWrap.classList.remove('is-visible');
      return;
    }
    existingWrap.classList.add('is-visible');
    list.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'retur-existing-item';
      btn.textContent = (TYPE_LABELS[item.return_type] || item.return_type) + ' — oprettet ' + formatDate(item.created_at);
      btn.addEventListener('click', function () { selectOption(item.return_type); });
      existingList.appendChild(btn);
    });
  }

  function showResult(data) {
    currentToken = data.token;

    if (trackingWrap) {
      trackingWrap.style.display = data.tracking_number ? '' : 'none';
      if (trackingEl) trackingEl.textContent = data.tracking_number || '';
    }

    if (resultPdfWrap) {
      resultPdfWrap.style.display = data.has_pdf ? '' : 'none';
      if (data.has_pdf && pdfLink) {
        pdfLink.href = backend + '/api/public/return-label/' + encodeURIComponent(currentToken) + '/pdf';
      }
    }

    if (resultQrWrap) {
      var showQr = data.return_type === 'ShopReturnQR' && data.has_qr;
      resultQrWrap.style.display = showQr ? '' : 'none';
      if (showQr && qrImg) {
        qrImg.src = backend + '/api/public/return-label/' + encodeURIComponent(currentToken) + '/qr.png';
      }
    }

    if (resultMailWrap) {
      resultMailWrap.style.display = data.return_type === 'ShopReturnMail' ? '' : 'none';
    }

    showView('result');
    clearMsg();

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('token', currentToken);
      url.searchParams.delete('ordre');
      url.searchParams.delete('email');
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ældre browsere — springer stille over */ }
  }

  function selectOption(returnType) {
    if (optionsInflight) return;
    setOptionsLoading(true);
    setMsg('Opretter din returlabel…', 'info');

    fetch(backend + '/api/public/return-label/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ order_number: currentOrderNumber, email: currentEmail, return_type: returnType })
    })
      .then(parseResponse)
      .then(function (out) {
        setOptionsLoading(false);
        var data = out.data || {};

        if (out.status === 429) {
          setMsg('For mange forsøg lige nu. Vent et øjeblik og prøv igen.', 'error');
          return;
        }
        if (data.success && data.token) {
          showResult(data);
          return;
        }
        setMsg(data.error || ('Kunne ikke oprette labelen. Kontakt os på ' + supportEmail + '.'), 'error');
      })
      .catch(function () {
        setOptionsLoading(false);
        setMsg('Der opstod en netværksfejl. Prøv igen om lidt.', 'error');
      });
  }

  function lookupOrder(orderNumber, email, website) {
    if (requestInflight) return;
    currentOrderNumber = orderNumber;
    currentEmail = email;

    setRequestLoading(true);
    setMsg('Slår din ordre op…', 'info');

    fetch(backend + '/api/public/return-label/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ order_number: orderNumber, email: email, website: website || '' })
    })
      .then(parseResponse)
      .then(function (out) {
        setRequestLoading(false);
        var data = out.data || {};

        if (out.status === 429) {
          setMsg('For mange forsøg lige nu. Vent et øjeblik og prøv igen.', 'error');
          return;
        }
        if (data.success) {
          if (orderNumberEl) orderNumberEl.textContent = data.order_number || '';
          renderExisting(data.existing);
          showView('choose');
          clearMsg();
          return;
        }
        setMsg(data.error || ('Vi kunne ikke finde din ordre. Kontakt os på ' + supportEmail + '.'), 'error');
      })
      .catch(function () {
        setRequestLoading(false);
        setMsg('Der opstod en netværksfejl. Tjek din forbindelse og prøv igen — eller kontakt os på ' + supportEmail + '.', 'error');
      });
  }

  function loadByToken(token) {
    setMsg('Henter din label…', 'info');
    fetch(backend + '/api/public/return-label/' + encodeURIComponent(token), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (out) {
        var data = out && out.data;
        if (out && out.success && data) {
          currentOrderNumber = data.order_number || '';
          showResult(data);
        } else {
          setMsg('Kunne ikke finde denne label — den kan være for gammel eller linket forkert.', 'error');
        }
      })
      .catch(function () {
        setMsg('Der opstod en netværksfejl. Prøv igen om lidt.', 'error');
      });
  }

  requestForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var orderNumber = (requestForm.querySelector('[name="order_number"]').value || '').trim();
    var email = (requestForm.querySelector('[name="email"]').value || '').trim();
    var website = (requestForm.querySelector('[name="website"]').value || '').trim();

    if (!orderNumber || !email) {
      setMsg('Udfyld venligst både ordrenummer og email.', 'error');
      return;
    }
    lookupOrder(orderNumber, email, website);
  });

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectOption(btn.getAttribute('data-retur-option'));
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (currentOrderNumber && currentEmail) {
        // Genopfrisk "allerede oprettet"-listen, så den lige oprettede label er med.
        lookupOrder(currentOrderNumber, currentEmail, '');
      } else {
        showView('choose');
        clearMsg();
      }
    });
  }

  // ── Indgange via query-parametre ──────────────────────────────────────────
  var params = new URLSearchParams(window.location.search);
  var qToken = params.get('token');
  var qOrdre = params.get('ordre');
  var qEmail = params.get('email');

  if (qToken) {
    loadByToken(qToken);
  } else if (qOrdre || qEmail) {
    if (qOrdre) requestForm.querySelector('[name="order_number"]').value = qOrdre;
    if (qEmail) requestForm.querySelector('[name="email"]').value = qEmail;
    if (qOrdre && qEmail) {
      requestForm.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }
})();
